import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import { Overview } from "./overview";
import { Users } from "./users";
import { Connectors } from "./connectors";
import { Credentials } from "./credentials";
import { Schedules } from "./schedules";
import { Versions } from "./versions";

const tabsData = ["overview", "users", "connectors", "credentials", "schedules", "versions"];

export const FlowTabs = () => {
   const [currentTab, setCurrentTab] = useState("overview");

   const renderTab = () => {
      switch (currentTab) {
         case "overview":
            return <Overview />;
         case "users":
            return <Users />;
         case "connectors":
            return <Connectors />;
         case "credentials":
            return <Credentials />;
         case "schedules":
            return <Schedules />;
         case "versions":
            return <Versions />;
      }

      return <></>;
   };

   return (
      <SoftBox>
         <SoftBox>
            <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
            {renderTab()}
         </SoftBox>
      </SoftBox>
   );
};
